<template>
  <div
    id="fee_writeofferr"
    v-loading.fullscreen.lock="pageLoading"
  >
    <div class="main">
      <div class="title_bar">
        <div class="left" />
        <div class="right">
          <span>搜尋結果共計{{ writeoffErrData.length }}筆</span>
        </div>
      </div>
      <list-frame
        v-loading="loadingList"
        :list-form="writeoffErrList"
        :list-data="writeoffErrData"
      >
        <el-table-column
          slot="Sn"
          label="銷帳編號"
          width="150"
        >
          <span slot-scope="scope">
            <p class="multiLines">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row['Sn']"
                placement="top"
              >
                <span>{{ scope.row['Sn'].length > 10 ? `...${scope.row['Sn'].slice(-10)}` : (scope.row['Sn'] || '-') }}</span>
              </el-tooltip>
            </p>
          </span>
        </el-table-column>
        <el-table-column
          slot="Rn"
          label="收據編號"
          width="150"
        >
          <span slot-scope="scope">
            <p class="multiLines">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row['Rn']"
                placement="top"
              >
                <span>{{ scope.row['Rn'].length > 10 ? `...${scope.row['Rn'].slice(-10)}` : (scope.row['Rn'] || '-') }}</span>
              </el-tooltip>
            </p>
          </span>
        </el-table-column>
        <el-table-column
          slot="StatusDesc"
          class-name="status-desc"
          width="500"
          label="狀態說明"
        >
          <template slot-scope="scope">
            因使用過去期別【{{ scope.row.BillBulkName }}】繳費單繳費，導致銷帳資料異常。<br>
            請向住戶確認正確繳費期別後，將此銷帳資料異動到該期別。
          </template>
        </el-table-column>
        <el-table-column
          slot="Operation"
          class-name="operation"
          width="130"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
              @click="handleChangeParentBill(scope.row)"
            >
              異動
            </el-button>
          </template>
        </el-table-column>
      </list-frame>
    </div>
    <el-dialog
      v-loading="loadingChange"
      title="銷帳資料異動"
      custom-class="sm-size"
      :visible.sync="writeoffChangeDialog"
      :close-on-click-modal="false"
      :show-close="false"
      :lock-scroll="true"
      center
      @closed="resetForm('writeoffChange')"
    >
      <el-form
        v-if="changeParentBillData"
        ref="writeoffChange"
        :model="changeParentBillData"
        status-icon
        @submit.native.prevent
      >
        <el-form-item label="戶別">
          {{ changeParentBillData.TabletNote }}
        </el-form-item>
        <el-form-item label="期別">
          <el-select
            v-if="tabletBillList.length > 0"
            v-model="changeParentBillId"
            placeholder="請選擇"
            size="small"
            filterable
          >
            <el-option
              v-for="(item, idx) in tabletBillList"
              :key="`writeofferr_bill_${item.BillId}_${idx}`"
              :label="item.BillBulkName"
              :value="item.BillId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="writeoffChangeDialog=false"
        >取消</el-button>
        <el-button
          type="primary"
          :disabled="loadingChange"
          round
          @click="saveChangeParentBill(changeParentBillData)"
        >確定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import listFrame from '@/components/ListFrame'
export default {
  components: {
    'list-frame': listFrame
  },
  data () {
    return {
      pageLoading: false,
      loadingList: false,
      loadingChange: false,
      writeoffChangeDialog: false,
      writeoffErrList: [
        {
          prop: 'TabletNote',
          label: '戶別'
        },
        {
          prop: 'PayDate',
          label: '繳費日期',
          width: '110',
          align: 'right'
        },
        {
          slot: 'Sn'
        },
        {
          slot: 'Rn'
        },
        {
          slot: 'StatusDesc'
        },
        {
          slot: 'Operation'
        }
      ],
      writeoffErrData: [],
      tabletBillList: [],
      changeParentBillId: 0,
      changeParentBillData: null
    }
  },
  mounted () {
    this.getListDefault()
  },
  methods: {
    getListDefault () {
      this.getList()
    },
    getList () { // 取得異常入帳款項列表
      this.loadingList = true
      apiBillservice.Writeoff.GetWriteoffErrList().then((res) => {
        console.log(res.data.Data)
        this.writeoffErrData = res.data.Data.map((e) => {
          e.PayDate = this.$formatDate(e.PayDate)
          return e
        })
        this.loadingList = false
      }).catch((err) => {
        this.$message({
          message: '取得異常入帳款項列表失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingList = false
      })
    },
    getTabletBillList (rowData) { // 取得戶別繳費單列表
      this.loadingChange = true
      const queryPath = {
        tabletId: rowData.TabletId
      }
      apiBillservice.BillBulk.GetTabletBillList(
        queryPath
      ).then((res) => {
        console.log(res.data.Data)
        this.tabletBillList = res.data.Data.filter(e => {
          return e.BillStatus === '開啟' && (+new Date() > +new Date(e.BillStartDate))
        })
        this.changeParentBillId = this.tabletBillList[0].BillId
        this.loadingChange = false
      }).catch((err) => {
        this.$message({
          message: '取得戶別繳費單列表失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingChange = false
      })
    },
    handleChangeParentBill (rowData) { // 建立銷帳資料
      this.tabletBillList = []
      this.changeParentBillData = rowData
      this.getTabletBillList(rowData)
      this.writeoffChangeDialog = true
    },
    saveChangeParentBill (rowData) { // 建立銷帳資料
      this.loadingChange = true
      this.writeoffChangeDialog = true
      const requestData = {
        BillId: this.changeParentBillId,
        ReceiptId: rowData.ReceiptId
      }
      apiBillservice.Writeoff.PostWriteoff(
        requestData
      ).then((res) => {
        console.log(res.data.Data)
        this.getList()
        this.loadingChange = false
        this.writeoffChangeDialog = false
      }).catch((err) => {
        this.$message({
          message: '銷帳資料異動失敗，請稍後再試',
          type: 'warning'
        })
        console.log(err.response)
        this.loadingChange = false
      })
    },
    resetForm (formName) { // 重置表格資料
      this.$refs[formName].resetFields()
    }
  }
}
</script>
<style lang="sass" scoped>
#fee_writeofferr
  text-align: center
  .main
    min-width: 900px
    color: $mainFontColor
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 20px 0
      .right
        span
          margin: 0 20px
          color: $mainFontColor
          vertical-align: middle
</style>
